export const branchAliases = {
  2: 'HANOVER',
  3: 'MT FOREST',
  4: 'KINCARDINE',
  5: 'GODERICH',
  6: 'OWEN SOUND',
  7: 'WINGHAM',
  8: 'ORILLIA',
  9: 'MIDLAND',
  10: 'MITCHELL',
  11: 'ORANGEVILLE',
  12: 'BARRIE',
  14: 'STRATFORD',
  15: 'PARRY AUTOMOTIVE',
  17: 'LISTOWEL',
  18: 'COLLINGWOOD',
  23: 'LISTOWEL MACHINE SHOP',
  27: 'HARRISTON',
  28: 'EXETER',
  29: 'WALKERTON',
  30: 'SHELBURNE',
  31: 'ALLISTON',
  32: 'PORT ELGIN',
  33: 'WOODSTOCK',
  34: 'ST MARYS',
  35: 'HALIBURTON',
  36: 'HUNTSVILLE',
  37: 'PARRY SOUND',
  38: 'KESWICK',
  39: 'WINDSOR',
  40: 'LEAMINGTON',
  41: 'FLESHERTON',
  42: 'NEW HAMBURG',
  43: 'BARRIE SOUTH',
  45: 'BRACEBRIDGE',
  47: 'DALTCO KINGSTON',
  48: 'DALTCO BROCKVILLE',
  49: 'DALTCO OTTAWA',
  50: 'RIDGETOWN',
  51: 'CHATHAM',
  52: 'WALLACEBURG',
  88: 'WAREHOUSE',
  98: 'WIRE WAREHOUSE',
} as const;
